import React from 'react';
import { Table, Button, Popconfirm, Space, Tooltip } from 'antd';
import { assetFormService } from '@iso/services';
import { CloseOutlined, EyeOutlined, FormOutlined, FileDoneOutlined } from '@ant-design/icons';
import FormListWrap from './FormListWrap.styles';

export default function FormList(props) {
    const {
        forms,
        loading,
        page,
        pageSize,
        total,
        onPageChange,
        onDeleted,
        openPreview,
        openSubmit,
        openSubmission,
    } = props;

    const handleDelete = (id) => {
      assetFormService.destroy(id).then(res => {
          if (res.code === '0000') {
              onDeleted(id); 
          } 
      });
    };

    const handlePreview = (record) => {
        if (openPreview) {
            openPreview(record);
        }
    };
    const handleSubmit = (record) => {
        if (openSubmit) {
            openSubmit(record);
        }
    };
    const handleSubmission = (record) => {
        if (openSubmission) {
            openSubmission(record);
        }
    };

    const columns = [
    {
      title: 'Form name',
      dataIndex: ['form', 'name'],
      render: (_, r) => (
        <div>
          <div><strong>{r.form?.name || '-'}</strong></div>
          <div style={{ fontSize: 12, color: '#888' }}>
            ID: {r.form?.id ?? '—'}
          </div>
        </div>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, r) => (
        <Space size={8}>
            <Tooltip title="Submit form">
              <Button size="small" onClick={() => handleSubmit(r)} style={{ borderColor: '#0B2A1B', color: '#0B2A1B' }}>
                <FormOutlined style={{ marginRight: 4 }} />
                Submit
              </Button>
            </Tooltip>
            <Tooltip title="View submissions">
              <Button size="small" onClick={() => handleSubmission(r)} style={{ borderColor: '#0B2A1B', color: '#0B2A1B' }}>
                <FileDoneOutlined style={{ marginRight: 4 }} />
                Submissions
              </Button>
            </Tooltip>
            <Tooltip title="Preview form">
              <Button size="small" onClick={() => handlePreview(r)} style={{ borderColor: '#0B2A1B', color: '#0B2A1B' }}><EyeOutlined /></Button>
            </Tooltip>
            <Popconfirm 
              title="Delete this form from asset?" 
              onConfirm={() => handleDelete(r.id)} 
              okText="Delete"
              okButtonProps={{ style: { backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' } }}
              cancelButtonProps={{ style: { backgroundColor: '#fff', borderColor: '#0B2A1B', color: '#0B2A1B' } }}
            >
              <Button size="small" danger><CloseOutlined /></Button>
            </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <FormListWrap className="form-list-wrap">
      <Table
        rowKey="id"
        columns={columns}
        dataSource={forms}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: false,
          onChange: (p) => onPageChange(p),
        }}
      />
    </FormListWrap>
  );
}
